import { use_slice_ui } from '@/hooks/store/use_slices';
import { INVOCATION__base } from '@shared/dto/generation/graph_invoke/_invocations/_base/INVOCATION__base';
import { HOOK_INVOCATION__has_effect_on_generation } from '../../../_hooks/HOOK_INVOCATION__has_effect_on_generation';

interface PROPS {
  invocation: INVOCATION__base;
}

export function G_GRAPH_NODE__invocation_overlay_not_used({ invocation }: PROPS) {
  let has_effect = HOOK_INVOCATION__has_effect_on_generation(invocation);

  const { g_graph__node_id_selected, g_graph__node_id_hovered } = use_slice_ui(['g_graph__node_id_hovered', 'g_graph__node_id_selected']);

  function get_opacity() {
    if (has_effect) return 'opacity-0';
    if (g_graph__node_id_selected == invocation.meta.node_id) return 'opacity-0';
    if (g_graph__node_id_hovered == invocation.meta.node_id) return 'opacity-0';

    return 'opacity-100';
  }

  let class_name_base = `absolute inset-0 size-full
  transition-opacity duration-300 ${get_opacity()} pointer-events-none`;

  return (
    <>
      <div className={` bg-black/80 border border-component-border rounded-lg  ${class_name_base}`} />
      <span className={`flex-center text-3xl font-bold text-component-item-foreground  ${class_name_base}`}>Not used</span>
    </>
  );
}
